<h1 mat-dialog-title class="dialog-title text-center fs-5">Tax Amount Distribution</h1>
<div mat-dialog-content>
  <div class="">
    <div class="row">
      <div class="col-md-6">
        <label class="f-label"> Code </label>
        <mat-form-field class="full-width" appearance="outline">
          <input type="text" matInput name="local_data.taxCode " [(ngModel)]="local_data.taxCode" disabled>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <label class="f-label"> Name </label>
        <mat-form-field class="full-width" appearance="outline">
          <input type="text" matInput disabled name="local_data.taxName " [(ngModel)]="local_data.taxName">
        </mat-form-field>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-12 tabledesign">
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="tax_parameter_name">
            <th mat-header-cell *matHeaderCellDef> Tax Parameter Name </th>
            <td mat-cell *matCellDef="let row"> {{row.tax_parameter_name}} </td>
            <td mat-footer-cell *matFooterCellDef> </td>
          </ng-container>
          <ng-container matColumnDef="tax_rate">
            <th mat-header-cell *matHeaderCellDef>Tax Rate</th>
            <td mat-cell *matCellDef="let row"> {{row.tax_rate}} </td>
            <td mat-footer-cell *matFooterCellDef> </td>
          </ng-container>
          <ng-container matColumnDef="base_amount">
            <th mat-header-cell *matHeaderCellDef>Base Amount </th>
            <td mat-cell *matCellDef="let row"> {{row.base_amount | number:'1.2-2'}} </td>
            <td mat-footer-cell *matFooterCellDef class="fw-bold"> Total </td>
          </ng-container>
          <ng-container matColumnDef="tax_amount">
            <th mat-header-cell *matHeaderCellDef>Tax Amount</th>
            <td mat-cell *matCellDef="let row" class="text-end"> {{row.tax_amount | number:'1.2-2'}}</td>
            <td mat-footer-cell *matFooterCellDef class="text-end fw-bold"> {{getTotalTaxAmount() | number:'1.2-2'}}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: this.displayedColumns;"></tr>
          <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
        </table>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Cancel</button>
</div>